import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Modals/RichTextModal/richTextModal"
    ).then((module) => ({
        default: module.RichTextModal
    }))
);
